import { render, staticRenderFns } from "./post_list.vue?vue&type=template&id=12f4c9dd&scoped=true&"
import script from "./post_list.vue?vue&type=script&lang=js&"
export * from "./post_list.vue?vue&type=script&lang=js&"
import style0 from "./post_list.vue?vue&type=style&index=0&id=12f4c9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4c9dd",
  null
  
)

export default component.exports